import React, { useState, useEffect } from 'react';
import { Box, Snackbar, OutlinedInput, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import {apiV1OrgUri} from 'constants/apiRoutes';
import {useMutation} from '@tanstack/react-query';
import * as http from '../../../util/elemental_axios_client';
import {enqueueSnackbar} from 'notistack';

const SidebarSaveTemplateAsNew = ({ template, onSavedAsNewTemplate }) => {
    console.log('SidebarSaveTemplateAsNew render with template:', template);
    console.log('onSavedAsNewTemplate callback exists:', !!onSavedAsNewTemplate);

    const [ templateName, setTemplateName ] = useState('');

    const onChange = (event) => {
        setTemplateName(event.target.value);
    };

    const mutationAddTemplate = useMutation(
        {
            mutationFn: async ( payload ) => {
                console.log('mutationAddTemplate.mutationFn called with payload:', payload);
                return await http.post('/content/email/templates', payload );
            },
            onSuccess: (newTemplate) => {
                console.log('mutationAddTemplate.onSuccess called with response:', newTemplate);
                enqueueSnackbar(`Successfully saved ${templateName}`, { variant: 'success' });
                if (onSavedAsNewTemplate) {
                    console.log('Calling onSavedAsNewTemplate with:', newTemplate);
                    onSavedAsNewTemplate(newTemplate);
                } else {
                    console.log('onSavedAsNewTemplate callback not provided');
                }
            },
            onError: (error) => {
                console.error('mutationAddTemplate.onError called with error:', error);
                enqueueSnackbar(`Unexpected error while saving ${templateName}`, { variant: 'error' });
            }
        }
    );

    const saveAsTemplate = async () => {
        console.log('saveAsTemplate called with template:', template);
        const payload = {
            title: templateName,
            template: template
        };
        console.log('Calling mutationAddTemplate.mutate with payload:', payload);
        mutationAddTemplate.mutate(payload);
    };

    return (
        <>
            <Box className='flow-sidebar'>
                <Box className='flow-sidebar__header'>
                    <Box>
                        <Typography component='div' variant='subtitle1' className='flow-sidebar_title' style={{border: 0}}>
                            Save as a New Template
                        </Typography>
                    </Box>
                </Box>
                <Box className='flow-sidebar__body' p={0} style={{width: '90%'}}>
                    <Box className='flow-sidebar__body-content' p={2} mt={2}>
                        <Typography variant='subtitle1'>Template Name</Typography>
                        <OutlinedInput id='outlined-basic' type='text' value={templateName} onChange={onChange} fullWidth style={{marginTop: 10}} autoFocus/>
                        <LoadingButton 
                            loading={mutationAddTemplate.isLoading}
                            className='new_primary_button' 
                            style={{marginLeft: '81%', marginRight: 0, marginTop: 25}} 
                            onClick={saveAsTemplate}
                        >
                            Save
                        </LoadingButton>
                    </Box>
                </Box>
            </Box>
        </>
    );
};

export default SidebarSaveTemplateAsNew;
